import React from "react";
import { StyledWrapperContent } from "./style";

const WrapperContent = props => {
  const { children, ...rest } = props;
  return <StyledWrapperContent {...rest}>{children}</StyledWrapperContent>;
};

export default WrapperContent;
